/**
 * GamePageWrapper Component
 * 
 * A wrapper for non-dashboard pages (Settings, Profile, etc.)
 * that provides consistent game-style header and layout.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import styles from './GamePageWrapper.module.scss';

interface GamePageWrapperProps {
  children: React.ReactNode;
  title: string;
  showBackButton?: boolean;
}

export const GamePageWrapper: React.FC<GamePageWrapperProps> = ({
  children,
  title,
  showBackButton = true,
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className={styles.pageWrapper}>
      {/* Header */}
      <header className={styles.header}>
        <div className={styles.headerLeft}>
          {showBackButton && (
            <button 
              className={styles.backButton}
              onClick={handleBack}
              aria-label="Go back"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path 
                  d="M15 18L9 12L15 6" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          )}
        </div>
        
        <h1 className={styles.title}>{title}</h1>
        
        <div className={styles.headerRight}>
          {/* Placeholder for future actions */}
        </div>
      </header>

      {/* Content */}
      <motion.main
        className={styles.content}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2 }}
      >
        {children}
      </motion.main>
    </div>
  );
};

export default GamePageWrapper;
